import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="result-avail"
export default class extends Controller {
  static targets = ['btn', 'modal']

  connect() {
    const container = this.modalTarget.querySelector('.availa-modal-container');
    document.addEventListener('click', (e) => {
      if(!this.btnTarget.contains(e.target) && !container.contains(e.target) ){
        this.close();
      }
    })
  }

  toggle() {
    this.modalTarget.classList.toggle('open');
  }

  close() {
    this.modalTarget.classList.remove('open');
  }
}
